import { render } from "./FirmalarDetayView.vue?vue&type=template&id=0af22619"
import script from "./FirmalarDetayView.vue?vue&type=script&lang=js"
export * from "./FirmalarDetayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__